module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-22.c4349216.png";